export const routes = {
  login: "/login",
  authHandoff: "/auth/handoff",
  authLogoutSync: "/auth/logout-sync",
  tenantDashboard: "/tenant/hospitol",
  dashboardFinance: "/tenant/hospitol/dashboard/finance",
  dashboardOperations: "/tenant/hospitol/dashboard/operations",
  directionHub: "/tenant/hospitol/direction",

  // Accueil & flux patient
  admissions: "/tenant/hospitol/admissions",
  emergency: "/tenant/hospitol/emergency",
  ambulanceTransports: "/tenant/hospitol/emergency/transports",
  appointments: "/tenant/hospitol/appointments",
  hospitalServicesHub: "/tenant/hospitol/services",

  // Patients
  patients: "/tenant/hospitol/patients",
  patientRecords: "/tenant/hospitol/patients/records",

  // Module Pharmacie (sous-module actif)
  pharmacyInvoice: "/tenant/hospitol/pharmacy/invoice",
  pharmacyOrders: "/tenant/hospitol/pharmacy/orders",
  pharmacyInvoiceHistory: "/tenant/hospitol/pharmacy/invoices",
  pharmacyStockScan: "/tenant/hospitol/pharmacy/stock/scan",
  pharmacyStockArticles: "/tenant/hospitol/pharmacy/stock/articles",

  // Laboratoire
  laboratory: "/tenant/hospitol/laboratory",
  labResults: "/tenant/hospitol/laboratory/results",

  // Imagerie
  imaging: "/tenant/hospitol/imaging",
  imagingReports: "/tenant/hospitol/imaging/reports",

  // Clinique
  consultations: "/tenant/hospitol/clinical/consultations",
  prescriptions: "/tenant/hospitol/clinical/prescriptions",
  surgery: "/tenant/hospitol/clinical/surgery",

  // Soins infirmiers & hospitalisation
  nursingCare: "/tenant/hospitol/nursing/care",
  hospitalization: "/tenant/hospitol/hospitalization",
  patientConsumables: "/tenant/hospitol/hospitalization/consumables",

  // RH (embed itaas-rh)
  rhEmployees: "/tenant/hospitol/rh/employees",
  rhDepartments: "/tenant/hospitol/rh/departments",
  rhSchedules: "/tenant/hospitol/rh/schedules",

  // Approvisionnement / stock hospitalier (embed inventory)
  supplyMedicinesArticles: "/tenant/hospitol/supply/medicines/articles",
  supplyMedicinesLevels: "/tenant/hospitol/supply/medicines/levels",
  supplyMedicinesReceipts: "/tenant/hospitol/supply/medicines/receipts",
  supplyMedicinesReceiptsHistory: "/tenant/hospitol/supply/medicines/receipts/history",
  supplyConsumablesArticles: "/tenant/hospitol/supply/consumables/articles",
  supplyConsumablesLevels: "/tenant/hospitol/supply/consumables/levels",
  supplyConsumablesReceipts: "/tenant/hospitol/supply/consumables/receipts",
  supplyConsumablesReceiptsHistory: "/tenant/hospitol/supply/consumables/receipts/history",
  /** Alias rétrocompat — médicaments */
  supplyArticles: "/tenant/hospitol/supply/medicines/articles",
  supplyLevels: "/tenant/hospitol/supply/medicines/levels",
  supplyReceipts: "/tenant/hospitol/supply/medicines/receipts",
  supplyReceiptsHistory: "/tenant/hospitol/supply/medicines/receipts/history",
  supplyAdminConsole: "/tenant/hospitol/supply/admin",
  rhAdminConsole: "/tenant/hospitol/rh/admin",
  billingAdminConsole: "/tenant/hospitol/billing/admin",

  // Facturation (embed billing + comptabilité native)
  billingAccounting: "/tenant/hospitol/billing/accounting",
  billingCashier: "/tenant/hospitol/billing/cashier",
  billingInvoices: "/tenant/hospitol/billing/invoices",

  // Administration
  adminMenuDemo: "/tenant/hospitol/admin/menu-demo",
  adminUsers: "/tenant/hospitol/admin/users",
  adminSettings: "/tenant/hospitol/admin/settings",
  adminIntegrations: "/tenant/hospitol/admin/integrations",
  hospitolSetup: "/tenant/hospitol/setup",

  // Assurance médicale
  insuranceHome: "/tenant/hospitol/insurance",
  insuranceInsurers: "/tenant/hospitol/insurance/insurers",
  insuranceCases: "/tenant/hospitol/insurance/cases",
  insurancePartnerships: "/tenant/hospitol/insurance/partnerships",

  /** Alias rétrocompat démo */
  invoice: "/tenant/hospitol/pharmacy/invoice",
  stockArticles: "/tenant/hospitol/pharmacy/stock/articles",
  stockScan: "/tenant/hospitol/pharmacy/stock/scan",
} as const;

export type HospitolRoute = (typeof routes)[keyof typeof routes];
